/* eslint-disable react/forbid-prop-types,import/no-unresolved */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { MAIN_ICON_COLORS } from 'assets/components';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import TransactionsFilters from '../../../../screens/Card/partials/TransactionsFilter';
import { getCardCapabilities } from '../../../../screens/Card/constants';

const IS_US_VERSION = process.env.REACT_APP_MINIMIZED_US_VERSION === 'true';

export const CardSearch = ({
  onChangeSearchTerm,
  searchObj,
  openCardSettingModal,
  handleKeyDown,
  setFilterBy,
  filterBy,
  calenderSearch = {},
  cardProvider = null,
}) => {
  const { t: translate } = useTranslation();

  const [isHoverCalendar, setIsHoverCalendar] = useState(false);
  const [isHoverSetting, setIsHoverSetting] = useState(false);

  return (
    <div className="d-none d-md-block row flex-row-center mx-2">
      <div className="d-flex flex-row justify-content-around px-0">
        {!IS_US_VERSION && (
          <div className="rounded bg-light p-0 popup-search-input d-flex flex-row flex-row-reverse position-relative">
            <input
              value={searchObj?.term}
              onChange={onChangeSearchTerm}
              name="search"
              className="form-control border-1 border-transparent bg-light shadow-none w-100 ps-5 d-flex"
              placeholder={translate('search_card_transactions_placeholder_text')}
              tabIndex={0}
              style={{ border: 'none' }}
            />
            {searchObj?.term && (
              <span
                className="position-absolute end-0 top-0 px-3 py-3 icon icon-close-other h-100 d-flex align-items-center justify-content-center text-shadow"
                onClick={() => onChangeSearchTerm(null)}
                onKeyDown={() => onChangeSearchTerm(null)}
                role="button"
                aria-label="Clear search"
                tabIndex={0}
              />
            )}
            <span className="position-absolute start-0 top-0 px-3 py-3 icon icon-search-other h-100 d-flex align-items-center justify-content-center text-shadow" />
          </div>
        )}
        <div className="d-flex gap-3 ms-auto p-2 pe-0 position-relative">
          {!IS_US_VERSION && <TransactionsFilters setFilterBy={setFilterBy} filterBy={filterBy} />}
          <div
            role="button"
            onClick={handleKeyDown}
            onKeyDown={handleKeyDown}
            onMouseEnter={() => setIsHoverCalendar(true)}
            onMouseLeave={() => setIsHoverCalendar(false)}
            aria-label="Calendar"
            tabIndex={-1}
            style={{ width: '1.5rem', height: '1.5rem' }}>
            <Icon
              icon={
                calenderSearch?.fromDate || calenderSearch?.toDate
                  ? ICONS?.FILLED_CALENDAR
                  : ICONS?.CALENDAR
              }
              color={
                calenderSearch?.fromDate || calenderSearch?.toDate || isHoverCalendar
                  ? MAIN_ICON_COLORS.PRIMARY
                  : MAIN_ICON_COLORS.WHITE
              }
            />
          </div>
          {getCardCapabilities(cardProvider).cardSettings && (
            <div
              role="button"
              onClick={openCardSettingModal}
              onKeyDown={openCardSettingModal}
              onMouseEnter={() => setIsHoverSetting(true)}
              onMouseLeave={() => setIsHoverSetting(false)}
              aria-label="Setting"
              tabIndex={-1}
              style={{ width: '1.5rem', height: '1.5rem' }}>
              <Icon
                icon={ICONS?.SETTING}
                color={isHoverSetting ? MAIN_ICON_COLORS.PRIMARY : MAIN_ICON_COLORS.WHITE}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardSearch;

CardSearch.propTypes = {
  onChangeSearchTerm: PropTypes.func.isRequired,
  openCardSettingModal: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  setFilterBy: PropTypes.func.isRequired,
  searchObj: PropTypes.object.isRequired,
  filterBy: PropTypes.string.isRequired,
  cardProvider: PropTypes.string,
  calenderSearch: PropTypes.object,
};
